import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import {
	UNDERWRITING_DECISIONS_NOTES_TITLE,
	UNDERWRITING_DECISIONS_NO_NOTES,
	UNDERWRITING_DECISIONS_TITLE,
} from '../../data/labelsAndMessages';
import { AutomatedUnderwritingResult } from '../../types/policy';
import { getUnderwritingDecisionText } from '../../util/util';
import { PaddedDiv, StyledTitleBolded } from '../common';

type Props = {
	basePolicyLocator: string;
	underwritingData: AutomatedUnderwritingResult;
};
const UnderWritingDecisionsTable = ({
	underwritingData,
	basePolicyLocator,
}: Props) => {
	const { decision, notes } = underwritingData;
	const renderNotes = () => {
		if (notes && notes.length > 0) {
			return notes.map((note, index) => {
				return (
					<TableRow key={`note-${index}`}>
						<TableCell>{note}</TableCell>
					</TableRow>
				);
			});
		} else {
			return (
				<TableRow key={'no-notes'}>
					<TableCell>{UNDERWRITING_DECISIONS_NO_NOTES()}</TableCell>
				</TableRow>
			);
		}
	};
	return (
		<PaddedDiv data-cy={`${basePolicyLocator}-underwriting`}>
			<StyledTitleBolded>
				{UNDERWRITING_DECISIONS_TITLE(getUnderwritingDecisionText(decision))}
			</StyledTitleBolded>
			<TableContainer>
				<Table size='small'>
					<TableHead>
						<TableRow>
							<TableCell>{UNDERWRITING_DECISIONS_NOTES_TITLE()}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>{renderNotes()}</TableBody>
				</Table>
			</TableContainer>
		</PaddedDiv>
	);
};

export default UnderWritingDecisionsTable;
